import * as React from 'react';

export const backArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="13"
    viewBox="0 0 9 13"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.94167 3.89118C7.3117 4.2612 7.3117 4.86112 6.94167 5.23114C6.57165 5.60116 5.97173 5.60116 5.60171 5.23114L4.5666 4.19603L4.5666 11.0613H8.0606C8.57948 11.0613 9.00012 11.482 9.00012 12.0009C9.00012 12.5197 8.57948 12.9404 8.0606 12.9404H3.95061C3.84743 12.9789 3.73573 13 3.6191 13C3.09581 13 2.6716 12.5758 2.6716 12.0525L2.6716 4.21426L1.60915 5.2767C1.24417 5.64169 0.652401 5.64169 0.287413 5.27671C-0.077575 4.91172 -0.0775753 4.31995 0.287413 3.95497L2.97646 1.26592L2.98557 1.25681C3.35056 0.891824 3.94232 0.891823 4.30731 1.25681L4.31183 1.26137L4.31642 1.26592L6.94167 3.89118Z"
    />
  </svg>
);
